import I18N from '@leverege/i18n'
import React from 'react'

import ShelfModel from './ShelfModel'
import ShelfMonitoring from './ShelfMonitoring'

const id = 'ps.dataViewers.ShelfMonitoringSupportDataViewer'

const { tf, tfIcon } = I18N.ns( id )

export default {
  id,
  type : 'ps.ShelfMonitoringSupport',
  name : tf( 'name' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : 'none',
  matches : { type : 'GroupDataViewer', objectType : 'segment' },
  createSettings : ( props ) => {
    return ShelfModel.create()
  },
  render : ( props ) => {
    return React.createElement( ShelfMonitoring, props )
  },
  getDefaultCardContentOptions : { height : 'auto' },
}
